module.exports = __webpack_public_path__ + "img/IMG_1149_L_WoodMatted_MockedUp.d5975422.jpg";